import { render } from "./_trends_table.vue?vue&type=template&id=124f755d&scoped=true"
import script from "./_trends_table.vue?vue&type=script&lang=js"
export * from "./_trends_table.vue?vue&type=script&lang=js"

import "./_trends_table.vue?vue&type=style&index=0&id=124f755d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124f755d"]])

export default __exports__